// @ts-nocheck

import { Network } from "@capacitor/network";
import { BehaviorSubject, from, switchMap } from "rxjs";

const networkStatusSubject = new BehaviorSubject<{ connected: boolean }>({ connected: true });

function onNetWorkStatusChanged(
) {
  return from(Network.removeAllListeners()).pipe(
    switchMap(() => Network.addListener("networkStatusChange", (status) => {
      networkStatusSubject.next({ connected: status.connected });
    })),
    switchMap(() => networkStatusSubject.asObservable())
  )
}

async function getNetworkStatus() {
  const { Network } = await import("@capacitor/network");
  return await Network.getStatus();
}

export { onNetWorkStatusChanged, getNetworkStatus };
